import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import { t } from "../app/Translate";
import Footer from "../components/Footer";
import { motion } from "framer-motion";
import { useState } from "react";

const Plans = () => {     
    const {isocode}: any = useParams();
    const navigate = useNavigate();

    function NavigateTo(id:number){
        let urlRegister = "/" + isocode + "/register/" + id
        navigate(urlRegister);
    }

    function NavigateToContact(){
        let urlRegister = "/" + isocode + "/contact/" 
        navigate(urlRegister);
    }

    function NavigateToFaq(){
        let urlRegister = "/" + isocode + "/faq/" 
        navigate(urlRegister);
    }
        
    return(
        <>
            <Header isocode={isocode} active="plans"/>
            <main className="main-content">
                <section className="header-plans">
                    <div className="row" style={{paddingTop:"130px",textAlign:"center"}}>
                        <div className="col-md-12 bannertext1">
                            {t("plans.title")}
                            <div className="bannertext2" style={{paddingLeft:"50px", paddingRight:"50px"}}>
                                {t("plans.subtitle")}
                            </div>                            
                        </div>                        
                    </div>                             
                </section>

                <section className="plan-section">                    
                    <div className="row">                        
                        <div className="col-md-3" key={1}>                            
                            {/* Card animada */}
                                <motion.div
                                    className="pricing-card"
                                    initial={{ opacity: 0, y: -50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: 1 * 0.3 + 0.2 }}
                                >
                                <h3 className="plan-name">{t("plans.plan1")}</h3>
                                <div className="plan-price">{t("plans.money")}{t("plans.price1")}</div>
                                <div className="plan-period">{t("plans.metodo")}</div>
                                <ul className="features-list">
                                    <li>{t("plans.user1")}</li>
                                    <li>{t("plans.item1")}</li>
                                    <li>{t("plans.item2")}</li>
                                    <li>{t("plans.item3")}</li>
                                    <li>{t("plans.item4")}</li>                                    
                                </ul>
                                <button onClick={() => NavigateTo(4)} className="animated-button">{t("plans.cta")}</button>
                            </motion.div>
                        </div>

                        <div className="col-md-3" key={2}>                            
                            {/* Card animada */}
                                <motion.div
                                    className="pricing-card"
                                    initial={{ opacity: 0, y: -50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: 1 * 0.3 + 0.2 }}
                                >
                                <h3 className="plan-name">{t("plans.plan2")}</h3>
                                <div className="plan-price">{t("plans.money")}{t("plans.price2")}</div>
                                <div className="plan-period">{t("plans.metodo")}</div>
                                <ul className="features-list">
                                    <li>{t("plans.user2")}</li>
                                    <li>{t("plans.item1")}</li>
                                    <li>{t("plans.item2")}</li>
                                    <li>{t("plans.item3")}</li>
                                    <li>{t("plans.item4")}</li>                                    
                                </ul>
                                <button onClick={() => NavigateTo(5)} className="animated-button">{t("plans.cta")}</button>
                            </motion.div>
                        </div>

                        <div className="col-md-3" key={3}>                            
                            {/* Card animada */}
                                <motion.div
                                    className="pricing-card"
                                    initial={{ opacity: 0, y: -50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: 1 * 0.3 + 0.2 }}
                                >
                                <div className="recommended-badge">{t("plans.recomended")}</div>
                                <h3 className="plan-name">{t("plans.plan3")}</h3>
                                <div className="plan-price">{t("plans.money")}{t("plans.price3")}</div>
                                <div className="plan-period">{t("plans.metodo")}</div>
                                <ul className="features-list">
                                    <li>{t("plans.user3")}</li>
                                    <li>{t("plans.item1")}</li>
                                    <li>{t("plans.item2")}</li>
                                    <li>{t("plans.item3")}</li>
                                    <li>{t("plans.item4")}</li>                                    
                                </ul>
                                <button onClick={() => NavigateTo(1)} className="animated-button">{t("plans.cta")}</button>
                            </motion.div>
                        </div>

                        <div className="col-md-3" key={4}>                            
                            {/* Card animada */}
                                <motion.div
                                    className="pricing-card"
                                    initial={{ opacity: 0, y: -50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: 1 * 0.3 + 0.2 }}
                                >                                
                                <h3 className="plan-name">{t("plans.plan4")}</h3>
                                <div className="plan-price">{t("plans.money")}{t("plans.price4")}</div>
                                <div className="plan-period">{t("plans.metodo")}</div>
                                <ul className="features-list">
                                    <li>{t("plans.user4")}</li>
                                    <li>{t("plans.item1")}</li>
                                    <li>{t("plans.item5")}</li>
                                    <li>{t("plans.item3")}</li>
                                    <li>{t("plans.item4")}</li>                                                                        
                                </ul>
                                <button onClick={() => NavigateTo(2)} className="animated-button">{t("plans.cta")}</button>
                            </motion.div>
                        </div>                       
                    </div>
                </section>
                <br/><br/>

                <section className="main-section" style={{padding:"70px", backgroundColor:"#282C40"}}>
                    <h2 className="whymakos-title" style={{color:"#ffffff"}}>{t("plans.plan5")}</h2>
                    <div className="row">
                        <div className="col-md-1"></div>                                    
                        <div className="col-md-6">
                            <motion.img
                                src="../../images/Enterprise-D.png"
                                style={{width:"80%"}}
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-4" style={{paddingTop:"70px",textAlign:"left"}}>                            
                            <div className="title-section1" style={{color:"#ffffff"}}>
                                {t("plans.plan5title")}
                            </div>
                            <div className="body-section1" style={{color:"#ffffff"}}>
                                {t("plans.plan5subtitle")}
                            </div>
                            <div className="body-section1" style={{color:"#ffffff"}}>
                                {t("plans.plan5options")}
                            </div>

                            <button onClick={NavigateToContact} className="animated-button" style={{marginTop:"15px"}}>{t("plans.plan5cta")}</button>
                        </div>        
                        <div className="col-md-1"></div>                                    
                    </div>
                </section>
                
                <section className="main-section1" style={{padding:"70px",textAlign:"center"}}>
                    <h2 className="whymakos-title" style={{color:"#282C40", paddingLeft:"0px", paddingRight:"0px"}}>{t("plans.plus")}</h2>
                    <div className="row">
                        <div className="col-md-1"></div>       
                        <div className="col-md-4" style={{textAlign:"left"}}>
                            <div className="title-section1" style={{color:"#282C40"}}>
                                {t("plans.plustitle")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40"}}>
                                {t("plans.plussubtitle")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40"}}>
                                {t("plans.plussubtitle1")}
                            </div>

                            <button onClick={NavigateToContact} className="animated-button" style={{marginTop:"25px"}}>{t("plans.pluscta")}</button>
                        </div>

                        <div className="col-md-6">
                            <motion.img
                                src="../../images/MakosPLUS.png"
                                width={500}                                
                                initial={{ opacity: 0, x: 100 }}   
                                whileInView={{ opacity: 1, x: 0 }} 
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                            />                            
                        </div>
                        <div className="col-md-1"></div>       
                    </div>
                </section>

                <section className="main-section2 padmakos">
                    <div className="bordercolors" style={{marginTop:"40px",marginBottom:"80px"}}>
                        <div className="bordercolorsbody">
                            <div className="row" style={{padding:"10px"}}>
                                <div className="col-md-1"></div>
                                <div className="col-md-7">
                                    <div className="cta-question" style={{color:"#282C40"}}>{t("plans.plusctaquestion")}</div>
                                    <div className="cta-message" style={{color:"#282C40"}}>{t("plans.plusctadetails")}</div>
                                </div>
                                <div className="col-md-3" style={{flexDirection:"column",display:"flex",paddingBottom:"30px", width:"100%"}}>                                                                        
                                    <center>
                                        <button onClick={NavigateToFaq} className="animated-button" style={{width:"100%",marginTop:"10px"}}>{t("plans.plusctaaction")}</button>                                        
                                    </center>
                                </div>
                                <div className="col-md-1"></div>
                            </div>                                                                                                 
                        </div>
                    </div>
                </section>

                <Footer isocode={isocode} />  
            </main>
        </>
    )
}

export default Plans;